"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "platania": {
    "42a0ced2": [{
      "hkey": "77c8b78c",
      "slug": "platania",
      "name": "Platania",
      "primary": true,
      "skipSearch": false
    }],
    "difesa-zito": [{
      "hkey": "77c8b78c",
      "slug": "platania",
      "name": "Platania",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "dbbdbd69": [{
      "hkey": "1fba41d1",
      "slug": "mercuri-tedesco",
      "name": "Mercuri Tedesco",
      "primary": true,
      "skipSearch": false
    }],
    "mercuri": [{
      "hkey": "1fba41d1",
      "slug": "mercuri-tedesco",
      "name": "Mercuri Tedesco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;